/**
 * Contesto di sessione: evita di passare `me` attraverso il router a ogni pagina.
 * Il provider viene montato solo quando la sessione esiste, quindi `useMe()` non
 * restituisce mai null e le pagine non devono gestire quel caso.
 */
import { createContext, useContext } from 'react';
import type { Me } from './types.js';

type SessionValue = { me: Me; logout: () => void };

const SessionContext = createContext<SessionValue | null>(null);

export function SessionProvider({
  value,
  children,
}: {
  value: SessionValue;
  children: React.ReactNode;
}) {
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession(): SessionValue {
  const value = useContext(SessionContext);
  if (!value) throw new Error('useSession fuori da SessionProvider');
  return value;
}
